import client from './base'

export interface Honoraire {
  id: number
  internal_id: number
  case_number: string
  client_id: string | null
  client_name: string
  tribunal_name: string
  total_fee: number
  total_paid: number       // deposits_received + formally_paid
  remaining: number
  status: 'pending' | 'paid' | 'partial' | 'unpaid'
  created_at: string

  // v2 breakdown fields
  deposits_received: number  // free CaseDeposits not yet applied to a formal invoice
  formally_paid: number      // ClientPayments recorded against formal invoices
  total_invoiced: number     // sum of net_a_payer of non-cancelled ClientInvoices
}

export interface HonoraireMeta {
  total_amount: number
  total_paid: number
  total_remaining: number
}

export interface HonoraireResponse {
  count: number
  total_pages: number
  current_page: number
  results: Honoraire[]
  meta: HonoraireMeta
}

export interface HonorairesParams {
  page?: number
  page_size?: number
  search?: string
  status?: string
  date_min?: string
  date_max?: string
  min_amount?: number
  max_amount?: number
  export?: 'excel' | 'pdf'
}

export const honorairesService = {
  list: async (params?: HonorairesParams) => {
    const response = await client.get<HonoraireResponse>('/api/v1/honoraires/', { params })
    return response.data
  },
  exportData: async (params: HonorairesParams) => {
    const response = await client.get('/api/v1/honoraires/', {
      params,
      responseType: 'blob', // Important for handling binary data
    })
    return response.data
  },
}
